/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { memo } from 'react';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { Glyphicon } from 'react-bootstrap';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';

import { heightRow } from '../helpers';

const MenuList = ({ filteredOptions, options, listRef, onSelectValue, values, isLoading, screenWidth, showOptionId, menuRef, groupKey }) => {
  const cache = new CellMeasurerCache({
    fixedWidth: true,
    minHeight: 26,
  });

  const rowCount = isArray(filteredOptions) ? filteredOptions.length : 0;

  const checkGroupSelected = (groupId) => {
    const findGroup = options?.find((opt) => opt.id === groupId);
    return findGroup?.[groupKey]?.every((item) => values.includes(item.id));
  };

  return (
    <ul
      ref={listRef}
      className="dropdown-menu__inner"
      style={{
        flex: '1 1 auto',
        height: `${
          filteredOptions.length < 11
            ? filteredOptions.map((item) => heightRow(item.title, screenWidth, menuRef?.current?.clientWidth)).reduce((a, b) => a + b, 0)
            : 350
        }px`,
      }}
    >
      <AutoSizer disableHeight>
        {({ width }) => (
          <List
            deferredMeasurementCache={cache}
            width={width}
            overscanRowCount={0}
            height={279}
            rowCount={rowCount}
            rowHeight={cache.rowHeight}
            scrollToIndex={isLoading && filteredOptions.length ? 0 : -1}
            rowRenderer={({ index, style, key, parent }) => {
              const elem = filteredOptions[index];

              if (elem.isGroupHeader) {
                const selected = checkGroupSelected(elem.id);
                return (
                  <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
                    <div key={index} style={style}>
                      {index !== 0 ? <li className="menu-item-divider" /> : null}
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          onSelectValue(elem.id, 'group');
                        }}
                        className={selected ? 'menu-item-header selected' : 'menu-item-header'}
                      >
                        <a href="# " role="button" className="item-link">
                          <span>{elem.title}</span>
                          {selected && <Glyphicon glyph="ok" />}
                        </a>
                      </li>
                    </div>
                  </CellMeasurer>
                );
              }

              return (
                <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
                  <li
                    key={elem.id}
                    style={style}
                    onClick={(e) => {
                      e.preventDefault();
                      onSelectValue(elem.id);
                    }}
                    className={values.includes(elem.id) ? 'menu-item selected' : 'menu-item'}
                  >
                    <a href="# " role="button" className="item-link">
                      {showOptionId && <span className="select-id">{elem.id}</span>}
                      <span>{elem.title}</span>
                      {values.includes(elem.id) && <Glyphicon glyph="ok" />}
                    </a>
                  </li>
                </CellMeasurer>
              );
            }}
          />
        )}
      </AutoSizer>
    </ul>
  );
};

MenuList.propTypes = {
  filteredOptions: PropTypes.array,
  options: PropTypes.array,
  listRef: PropTypes.object,
  onSelectValue: PropTypes.func,
  values: PropTypes.array,
  isLoading: PropTypes.bool,
  screenWidth: PropTypes.number,
  showOptionId: PropTypes.bool,
  menuRef: PropTypes.object,
  groupKey: PropTypes.string,
};

export default memo(MenuList);
